const esJSON = {};

export default esJSON;
